import { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../../components/ui";
import { Textarea } from "../../../components/ui/textarea";

/**
 * Ask for a mandatory reason before a compliance action (void a version, mark
 * a requirement not applicable). The reason is kept on the audit log.
 */
export default function ReasonDialog({ open, title, description, confirmLabel = "Confirm", variant = "default",
  loading = false, onConfirm, onClose }) {
  const [reason, setReason] = useState("");
  useEffect(() => { if (open) setReason(""); }, [open]);
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason (required, recorded on the compliance audit log)"
          rows={3}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>Cancel</Button>
          <Button
            variant={variant === "danger" ? "destructive" : "default"}
            disabled={loading || !reason.trim()}
            onClick={() => onConfirm?.(reason.trim())}
          >
            {loading ? "Saving..." : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
